import React from 'react';
import me2 from '../../images/me2.png'
const About = () => {
    return (
        <div id='about' className='mx-12 py-16'>
            <h2 className='text-3xl text-center font-bold my-4'> About me</h2>
            <div className=' grid sm:grid-cols-1 sm:w-5/5  lg:grid-cols-3  items-center  bg-[#090222] mx-auto] rounded'>
                <div>
                <img className='w-[80%] rounded text-center mx-auto' src={me2} alt="" />
            </div>
                <div className='p-2'>
                    <h1 className='sm:text-xl lg:text-4xl text-[#f5f6f7]'>I'm Shahidul Islam</h1>
                    <p className='text-[#f6f7fa]'>I'm a junior react frontend developer</p>
                    
                </div>
                <div className='px-5 '>
                    <p className='text-[#f3f5f8] p-4'>
                        <q>
                        I develop react front-end here. I always try to serve my output as world-class work . I feel comfortable using unique things in my development work . I like to take up any new topic related to web development and I like it so much that I can discover something new.
I think code gets its perfection by writing a programmer’s skill.
                    </q>

                    </p>
                </div>
            </div>
           
        </div>
    );
};

export default About;